import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import QrCode from 'qrcode.react';
import dayjs from 'dayjs';

/**
 * 교육일지 QR 임시 세션 표시 — 스캔 값은 평문 sessionId(GUID)
 */
function TRA_CUSTOM_02_QrModal({
  open,
  onClose,
  sessionId,
  expireDate,
}) {
  const expText = expireDate
    ? dayjs(expireDate).format('YYYY-MM-DD HH:mm')
    : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>참석 QR 코드</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          참석자가 휴대폰으로 스캔한 뒤 서명·등록하면 아래 세션에 반영됩니다. 교육일지
          저장 시 서버에 연결됩니다.
        </Typography>
        {sessionId ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              py: 1,
            }}
          >
            <Box
              sx={{
                p: 2,
                bgcolor: '#fff',
                borderRadius: 1,
                border: '1px solid #e0e0e0',
              }}
            >
              <QrCode value={sessionId} size={200} level="M" />
            </Box>
            <Typography variant="caption" color="text.secondary" align="center">
              세션 ID (모바일 연동용)
            </Typography>
            <Typography
              variant="body2"
              sx={{
                wordBreak: 'break-all',
                fontFamily: 'monospace',
                bgcolor: '#f5f5f5',
                p: 1,
                borderRadius: 1,
                width: '100%',
                textAlign: 'center',
              }}
            >
              {sessionId}
            </Typography>
            {expText ? (
              <Typography variant="caption" color="text.secondary">
                만료: {expText}
              </Typography>
            ) : null}
          </Box>
        ) : (
          <Typography color="text.secondary">세션을 불러오는 중입니다.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TRA_CUSTOM_02_QrModal;
